import script from "./SearchSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchSelect.vue?vue&type=script&lang=ts&setup=true"

import "./SearchSelect.vue?vue&type=style&index=0&id=215f512a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215f512a"]])

export default __exports__